module.exports = __webpack_public_path__ + "img/coricidin_hbp_maximum_strength_cold_flu_day_night_liquid_gels.b53952e9.png";